import { TeachingLocation } from 'types/location'
import { authorizedGet } from '..'

export type SearchLocationsProps = {
  query: string
  countryCode?: string
}

export type SearchLocationsResults = {
  results: TeachingLocation[]
}

export const searchLocations = async ({
  query,
  countryCode,
}: SearchLocationsProps): Promise<SearchLocationsResults> => {
  try {
    const params = { query, countryCode } as SearchLocationsProps

    const response = await authorizedGet({
      endpoint: `location/search`,
      params,
    })
    return (await response.json()) as SearchLocationsResults
  } catch (e) {
    throw e
  }
}
